import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent {

  @Input() title: string;
  @Input() body: string;
  @Input() isConfirm: boolean;
  @Input() isLinkDisplay: boolean;
  @Output() clickPositive: EventEmitter<unknown> = new EventEmitter();
  @Output() clickDismiss: EventEmitter<unknown> = new EventEmitter();
  @Output() clickLink: EventEmitter<unknown> = new EventEmitter();

  @ViewChild("content") modalRef: TemplateRef<unknown>;

  constructor(
    private modalService: NgbModal,
  ) { }

  open(): void {
    this.modalService.open(this.modalRef);
  }

  close(): void {
    this.modalService.dismissAll();
  }

  clickedPositive(): void {
    this.close();
    this.clickPositive.emit();
  }

  clickedDismiss(): void {
    this.close();
    this.clickDismiss.emit();
  }

}
